export default [      
    { name:'testMode', path: '/testMode', component: () => import('@/views/test-mode/index'), meta: {
        roles: ['student']
    } }, 
]